import { MainTabsProps } from "../MainTabs/MainTabs.types";
import { YellowTabsRoot } from "./YellowTabs.styles";

export default function YellowTabs({ tabs, ...rest }: MainTabsProps) {
    return <YellowTabsRoot tabs={tabs} {...rest} />;
}
